import { useIntl } from 'react-intl';

import { Sport } from '#src/__generated__/globalTypes.ts';
import { LiveRadar } from '#src/atoms/icons/LiveRadar.tsx';
import { Scores } from '#src/atoms/icons/Scores.tsx';
import { TopPlayers } from '#src/atoms/icons/TopPlayers.tsx';
import {
  ANY_SPORT_SCORES,
  ANY_SPORT_SCORES_MATCHES,
  ANY_SPORT_SCORES_TOP_PLAYERS,
} from '#src/constants/__generated__/routes.ts';
import { useSeriesNav } from '#src/hooks/commonGame/useSeriesNav.ts';
import { glossary, navLabels } from '#src/lib/glossary.ts';
import { generateSportPath } from '#src/lib/routing/generateSportPath.ts';

import { NavItemWithSubNav } from '../NavItemWithSubNav/index.tsx';
import { useNavItemLayout } from '../useNavItemLayout.ts';

type Props = { sport: Sport; sidebarCollapsed?: boolean };

export const ScoresNavItem = ({ sport, sidebarCollapsed }: Props) => {
  const { formatMessage } = useIntl();
  const { navItemsVariant, iconSize } = useNavItemLayout();
  const seriesNav = useSeriesNav();

  if (seriesNav) {
    return null;
  }

  return (
    <NavItemWithSubNav
      item={{
        variant: navItemsVariant,
        icon: ({ isActive }) => <Scores size={iconSize} active={isActive} />,
        label: formatMessage(navLabels.scores),
        to: generateSportPath(ANY_SPORT_SCORES, {
          sport,
        }),
        sidebarCollapsed,
        enableContextModeNavigation: true,
        subItems: [
          {
            icon: () => <LiveRadar size={2} />,
            label:
              sport === Sport.FOOTBALL
                ? formatMessage(navLabels.matches)
                : formatMessage(glossary.games),
            to: generateSportPath(ANY_SPORT_SCORES_MATCHES, {
              sport,
            }),
          },
          {
            icon: () => <TopPlayers size={2} />,
            label: formatMessage(glossary.topPlayers),
            to: generateSportPath(ANY_SPORT_SCORES_TOP_PLAYERS, {
              sport,
            }),
          },
        ],
      }}
    />
  );
};
